import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { plantDetailRoute } from "@/pages/PlantDetail/route";

// Aporta el segmento `ncu/$ncuName` y el crumb de la NCU, y sirve de raíz común
// de la pantalla de NCU (su índice) y de los detalles de TCU/HSU, que son
// pantallas propias y por eso cuelgan como hermanos, no dentro de la NCU. Sin
// `component` la ruta solo renderiza su `<Outlet/>`: el acceso no se cierra por
// estado de planta, cada dispositivo se rige por su `commissioning_state` (#3955).
export const plantNcuDetailRoute = createRoute({
  path: "ncu/$ncuName",
  getParentRoute: () => plantDetailRoute,
  staticData: { crumb: "ncu" },
  // Fuerza un remount completo al cambiar de NCU: el SSE de useSSE no resetea
  // su último dato al reconectar, así que sin esto el chip podía arrastrar un
  // instante el estado de la NCU anterior. Sin `component`, sigue aplicando
  // sobre el `<Outlet/>` por defecto.
  remountDeps: ({ params }) => params.ncuName,
});

export const plantNcuDetailIndexRoute = createRoute({
  path: "/",
  getParentRoute: () => plantNcuDetailRoute,
  component: lazyRouteComponent(async () => {
    const m = await import("./PlantNcuDetail");
    return { default: m.PlantNcuDetail };
  }),
});
